// This file is generated by a script and should not be modified directly.
const markdown: string =
  "Le statut de l'offre (cycle de vie) :\n\n- Active : L'offre est disponible sur la plateforme et il est possible d'y postuler.\n- Filled : L'offre a été pourvue et n'est donc plus disponible.\n- Cancelled : L'offre a été annulée et n'est donc plus disponible.\n"
export default markdown
